// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".take-alert[data-v-0e7f9300]{display:flex;align-items:center;background:var(--v-red-light-base);color:var(--v-red-base);border:1px solid var(--v-red-base);border-radius:8px;padding:8px 16px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
